var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReachstackerWithPricetag = function SvgReachstackerWithPricetag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 129,
    viewBox: "0 0 160 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 47.083 127.083 67.5a5.07 5.07 0 0 1-1.714 1.125 5.13 5.13 0 0 1-1.89.375c-.625 0-1.25-.125-1.875-.375a4.993 4.993 0 0 1-1.687-1.125L92.5 40.167c-.5-.445-.875-.98-1.125-1.607A5.286 5.286 0 0 1 91 36.583v-20.5c0-1.397.486-2.594 1.458-3.59.973-.995 2.18-1.493 3.625-1.493h20.5a4.88 4.88 0 0 1 1.949.406 5.227 5.227 0 0 1 1.635 1.094L147.5 39.833a4.69 4.69 0 0 1 1.142 1.715 5.283 5.283 0 0 1 0 3.825 4.847 4.847 0 0 1-1.142 1.71Zm-22.083 18.75 20.416-20.416c.556-.556.834-1.209.834-1.959s-.278-1.402-.834-1.958l-28.166-28.083H96.083c-.777 0-1.43.25-1.958.75s-.792 1.139-.792 1.916v20.5c0 .334.056.667.167 1 .111.334.306.64.583.917L121.5 65.833c.556.556 1.208.834 1.958.834s1.403-.278 1.959-.834ZM101.882 24.75c.801 0 1.479-.276 2.035-.827.555-.55.833-1.22.833-2.006 0-.81-.276-1.499-.827-2.066a2.69 2.69 0 0 0-2.006-.851c-.81 0-1.499.28-2.066.84A2.763 2.763 0 0 0 99 21.884c0 .8.28 1.478.84 2.034.561.555 1.242.833 2.042.833Z",
    fill: "#2C112D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7 105.1c3.9 0 7.1-3.2 7.1-7.1 0-3.9-3.2-7.1-7.1-7.1-3.9 0-7.1 3.2-7.1 7.1.1 4 3.2 7.1 7.1 7.1ZM96.2 105.1c3.9 0 7.1-3.2 7.1-7.1 0-3.9-3.2-7.1-7.1-7.1-3.9 0-7.1 3.2-7.1 7.1 0 4 3.2 7.1 7.1 7.1Z",
    stroke: "#2C112D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 85.3h14.2l5.7 17h28.3l5.7-17h19.8M26.8 57H7v8.5h19.8V57ZM16.9 48.5V57",
    stroke: "#2C112D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 91h11.3l7.7-12.8c.5-.9 1.4-1.4 2.4-1.4H75c1.6 0 2.8 1.3 2.8 2.8v11.3h5.7M60.8 91h17M52.3 91l14.2-31.2M93.2 64.5l-6.9 20.8",
    stroke: "#2C112D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.665 39.014 82.07 50.107l2.398 2.428-68.4-11.427-1.916 3.903 81.67 19.024 2.328 2.358a.996.996 0 0 1-.676.08l-85-19.8a1 1 0 0 1-.671-1.414l2.8-5.7a1 1 0 0 1 1.062-.545Z",
    fill: "#2C112D"
  })));
};
export default SvgReachstackerWithPricetag;